// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Tooltip = require("../common/Components/Tooltip.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let IconButton = require("../common/Components/IconButton.bs.js");
let ConfirmDialog = require("../common/Components/ConfirmDialog.bs.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let SubuserMemberEditForm = require("./SubuserMemberEditForm.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");
let SubusersPageAccountsListItem_member_graphql = require("../../__generated__/SubusersPageAccountsListItem_member_graphql.bs.js");
let SubusersPageAccountsListItem_account_graphql = require("../../__generated__/SubusersPageAccountsListItem_account_graphql.bs.js");
let SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql = require("../../__generated__/SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.bs.js");

function SubusersPageAccountsListItem$ConfirmRemoveDialog(props) {
  let name = props.name;
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsx(ConfirmDialog.make, {
      title: `Remove ` + name + `?`,
      ariaLabel: `Confirm removal of ` + name,
      body: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            children: name + " will be permanently removed from your account. You will assume ownership of all their clients and messages.",
            className: "leading-normal"
          }),
          JsxRuntime.jsx("br", {}),
          JsxRuntime.jsx("span", {
            children: "Once confirmed, the removal is not reversible.",
            className: "font-bold"
          })
        ]
      }),
      isOpen: props.isOpen,
      onCancel: onCancel,
      cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => onCancel(),
        children: "Cancel"
      }),
      confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
        onClick: param => onConfirm(),
        children: "Yes, remove them"
      })
    })
  });
}

let ConfirmRemoveDialog = {
  View: undefined,
  Buttons: undefined,
  make: SubusersPageAccountsListItem$ConfirmRemoveDialog
};

let convertFragment = SubusersPageAccountsListItem_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersPageAccountsListItem_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

let AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = SubusersPageAccountsListItem_member_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersPageAccountsListItem_member_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

let MemberFragment_accountMemberRole_decode = SubusersPageAccountsListItem_member_graphql.Utils.accountMemberRole_decode;

let MemberFragment_accountMemberRole_fromString = SubusersPageAccountsListItem_member_graphql.Utils.accountMemberRole_fromString;

let MemberFragment = {
  accountMemberRole_decode: MemberFragment_accountMemberRole_decode,
  accountMemberRole_fromString: MemberFragment_accountMemberRole_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertVariables;

let convertResponse = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let RemoveMemberV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function SubusersPageAccountsListItem(props) {
  let currentUserRole = props.currentUserRole;
  let match = use$2();
  let removeMember = match[0];
  let member = RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, props.member);
  let account = RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_account_graphql.node, convertFragment, props.account);
  let match$1 = React.useState(() => false);
  let setIsEditing = match$1[1];
  let match$2 = member.agent;
  let firstName = match$2.firstName;
  let name;
  if (firstName !== undefined) {
    let lastName = match$2.lastName;
    name = lastName !== undefined ? firstName + " " + lastName : firstName;
  } else {
    let lastName$1 = match$2.lastName;
    name = lastName$1 !== undefined ? lastName$1 : match$2.displayName;
  }
  let match$3 = member.role;
  let memberCanBeEdited = match$3 !== undefined && (match$3 === "ASSISTANT" || match$3 === "UNKNOWN" || match$3 === "ASSOCIATE" || match$3 === "TRANSACTION_COORDINATOR" || match$3 === "BUYER_SPECIALIST" || match$3 === "SHOWING_ASSISTANT" || match$3 === "CLIENT_CARE_COORDINATOR" || match$3 === "PARTNER" || match$3 === "INSIDE_SALES_AGENT" || match$3 === "OWNER" || match$3 === "LISTING_MANAGER" || match$3 === "OPERATIONS_MANAGER" || match$3 === "LISTING_SPECIALIST" || match$3 === "MARKETING_SPECIALIST") ? match$3 !== "OWNER" : true;
  let canEdit = currentUserRole === "OWNER";
  let match$4 = SystemMessages.useSystemMessages();
  let addMessage = match$4.addMessage;
  let addErrorMessage = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem removing the member. Please try again or contact us.", 5000, undefined, undefined));
  let addSuccessMessage = () => addMessage(SystemMessages.Message.make(undefined, "info", "The member was removed successfully", 5000, undefined, undefined));
  let removeMember$1 = () => {
    removeMember({
      connections: [SubusersPageAccountsList_account_graphql.makeConnectionId(account.__id)],
      input: {
        id: member.id
      }
    }, undefined, undefined, undefined, (response, param) => {
      let match = response.removeMemberV5;
      if (match === undefined) {
        return addErrorMessage();
      }
      switch (match.__typename) {
        case "AccountMemberRemoved" :
          return addSuccessMessage();
        case "SubuserInvitationFailed" :
        case "__unselected" :
          return addErrorMessage();
      }
    }, undefined, undefined);
  };
  let match$5 = React.useState(() => false);
  let setConfirmRemoveDialogOpen = match$5[1];
  let actions = memberCanBeEdited ? JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Tooltip.make, {
          label: canEdit ? "Edit the member's role" : "Only the account owner can edit member roles",
          children: JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconButton.make, {
              icon: "pencil",
              onPress: () => setIsEditing(param => true),
              title: "Edit user",
              disabled: !canEdit
            })
          })
        }),
        JsxRuntime.jsx(Tooltip.make, {
          label: canEdit ? "Remove the member from your account" : "Only the account owner can remove members",
          children: JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconButton.make, {
              icon: "trash",
              onPress: () => setConfirmRemoveDialogOpen(param => true),
              title: "Remove user",
              disabled: !canEdit || match[1]
            })
          })
        })
      ],
      className: "flex flex-row space-x-1"
    }) : null;
  let confirmation = JsxRuntime.jsx(SubusersPageAccountsListItem$ConfirmRemoveDialog, {
    isOpen: match$5[0],
    onConfirm: () => {
      removeMember$1();
      setConfirmRemoveDialogOpen(param => false);
    },
    onCancel: () => setConfirmRemoveDialogOpen(param => false),
    name: name
  });
  return props.render(name, member, actions, confirmation, match$1[0] ? JsxRuntime.jsx(SubuserMemberEditForm.make, {
      member: member.fragmentRefs,
      onClose: () => setIsEditing(param => false)
    }) : undefined);
}

let make = SubusersPageAccountsListItem;

exports.ConfirmRemoveDialog = ConfirmRemoveDialog;
exports.AccountFragment = AccountFragment;
exports.MemberFragment = MemberFragment;
exports.RemoveMemberV5Mutation = RemoveMemberV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
